import { ref } from 'vue'
import { useUserStore } from '../stores/userStore'
import { api } from '../services'
import type { LeaderboardEntry } from '../types'

/**
 * Profile data composable to handle profile-related data fetching
 * Abstracts data access from the presentation layer
 */
export function useProfileData() {
  const userStore = useUserStore()
  const userRank = ref(0)

  /**
   * Get leaderboard data through proper API service
   */
  const getLeaderboardData = async (): Promise<LeaderboardEntry[]> => {
    try {
      return await api.leaderboard.getLeaderboard()
    } catch (error) {
      console.error('Error fetching leaderboard data:', error)
      return []
    }
  }

  /**
   * Calculate user's rank from leaderboard data
   */
  const getUserRank = async (): Promise<number> => {
    try {
      const leaderboard = await getLeaderboardData()
      if (Array.isArray(leaderboard)) {
        const rank = leaderboard.findIndex(entry => 
          entry.customer_id === userStore.user?.customer_id
        ) + 1
        userRank.value = rank
        return rank
      } else {
        userRank.value = 0
        return 0
      }
    } catch (error) {
      console.error('Error calculating user rank:', error)
      userRank.value = 0
      return 0
    }
  }

  /**
   * Load all profile-related data
   */
  const loadProfileData = async (): Promise<void> => {
    await Promise.all([
      userStore.loadUser(),
      getUserRank()
    ])
  }

  return {
    userRank,
    getLeaderboardData,
    getUserRank,
    loadProfileData
  }
} 